<template>
  <flow-widget :org-ref="orgRef" :flow-id="flowId" :key="`${orgRef}-${orgRef}-flows`" />
</template>

<script>
import { FlowWidget } from '../widgets'
export default {
  components: { FlowWidget },
  props: {
    flowId: {
      type: [String, Number],
      required: true
    },
    orgRef: {
      type: String
    }
  }
}
</script>
